"use client"

import { View, StyleSheet } from "react-native"
import { Text, useTheme } from "react-native-paper"
import { TowerDetailsSection } from "./Sections/TowerDetailsSection"
import { FoundationDetailsSection } from "./Sections/FoundationDetailsSection"
import type { TabComponentProps } from "../../../types/tabs"

export function DashboardsTab({ selectedNode, projectData }: TabComponentProps) {
  const theme = useTheme()

  if (!selectedNode || (selectedNode.type !== "line" && selectedNode.type !== "section")) {
    return (
      <View style={[styles.empty, { backgroundColor: theme.colors.elevation.level1 }]}>
        <Text style={{ color: theme.colors.onSurfaceVariant }}>Select a line or section to view details</Text>
      </View>
    )
  }

  return (
    <View style={[styles.container, { backgroundColor: theme.colors.elevation.level1 }]}>
      <View style={styles.content}>
        <TowerDetailsSection selectedNode={selectedNode} projectData={projectData} />
        <FoundationDetailsSection selectedNode={selectedNode} projectData={projectData} />
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: "100%",
    overflow: "auto", // Changed from undefined to "auto"
  },
  content: {
    padding: 16,
  },
  empty: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
  },
})

